import { Form } from 'antd';
import React from 'react';
import { fieldNames } from '../../../common/config';
import { getRenderControl } from '../../../../../../../components/SingleControlCustom/getRenderControl';
import DropdownSelect from '../../../../../../../components/dropdownSelect';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import { useShutdownReasons } from '../../../../../shared/api/queries/shutdownReasons';

const reasonFieldName = fieldNames.reason;
const FormItem = Form.Item;

const ReasonField = ({ form }) => {
  const { data = [], isFetching } = useShutdownReasons({ staleTime: Infinity });

  const options = getOptionsBySelect(data);

  return (
    <FormItem
      label="Причина"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(reasonFieldName, {
        rules: [
          {
            required: true,
            message: 'Укажите причину',
          },
        ],
      })(
        <DropdownSelect
          multiple={false}
          options={options}
          renderControl={getRenderControl({
            options: options,
            isClear: false,
            value: form.getFieldValue(reasonFieldName),
            disabled: isFetching,
            loading: isFetching,
          })}
        />
      )}
    </FormItem>
  );
};

export default ReasonField;
